// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3QJuX","detailsBorder":"styles_detailsBorder__ZJQU6"};